import { type CloudFlowNodeType } from "@doitintl/cmp-models";
import NotificationIcon from "@mui/icons-material/NotificationsNone";
import { Card, Stack } from "@mui/material";

import { cloudflowTexts } from "../../../../../assets/texts";
import { Loader } from "../../../../../Components/Loader";
import { ReferencedFieldContextProvider } from "../../ApiActionParametersForm/parameters/wrappers/ReferencedField/ReferencedFieldContextProvider";
import { useReferenceableNodes } from "../../Common/hooks/useReferenceableNodes";
import { useNodeConfigurationContext } from "../NodeConfigurationContext";
import { NodeCardHeader } from "./NodeCardHeader";
import { NotificationForm } from "./Notification/NotificationForm";

const NotificationParametersTab = () => {
  const { nodeConfig } = useNodeConfigurationContext<CloudFlowNodeType.NOTIFICATION>();

  const { referenceableNodes, loading: referenceableNodesLoading } = useReferenceableNodes(nodeConfig.id);

  return (
    <Stack
      sx={{
        p: 2,
        justifyContent: "center",
        gap: 2,
      }}
    >
      <Card>
        <NodeCardHeader
          avatar={<NotificationIcon color="primary" fontSize="small" />}
          subheader={cloudflowTexts.NOTIFICATION_NODE_TITLE}
          title={cloudflowTexts.NOTIFICATION_NODE_DESCRIPTION}
        />
      </Card>
      <Loader loading={referenceableNodesLoading}>
        <ReferencedFieldContextProvider referenceableNodes={referenceableNodes}>
          <NotificationForm />
        </ReferencedFieldContextProvider>
      </Loader>
    </Stack>
  );
};

export default NotificationParametersTab;
